class StateMenuDirective {
    
    static factory (menu, $rootScope, $state, securityService, timer, helperService) {
       
       return {
            replace:true,
            restrict:'A',
            templateUrl: 'app/menu/state-menu.html',
            compile: function compile(tElement, tAttributes, transcludeFn) {
                let userRole = securityService.getAutheticatedUserRoles();
                let generateMenu = function(userRole, menu, stateMenu, isSub, menuDom) {
                    menuDom = menuDom + "<li class='is-active-ancestor has_sub'>";
                    menuDom = menuDom + `<a ui-sref="${stateMenu.state}" ui-sref-opts="{reload: true}" class="ng-binding">${stateMenu.text}</a>`;
                    menuDom = menuDom + "<ul>";
                    for (var option of menu) {
                        let classString = "";
                        if (option.sub) {
                            classString = classString + "class=has-subnav";
                        }
                        let ngClassString = `ng-class="{'is-active': stateIsActive('${option.state}')}"`;
                    //if (userRole === option.role) {
                            menuDom = menuDom + `<li ${classString} ${ngClassString} role="menuitem" aria-haspopup="true">`;
                            let stateParts = option.state.split('.');
                            stateParts.shift();
                            let menuId = stateParts.join('');
                            menuDom = menuDom + `<a id="${menuId}" ui-sref="${option.state}" ui-sref-opts="{reload: true}" class="ng-binding">${option.text}</a>`;
                            if (option.sub) {
                                menuDom = generateMenu(userRole, option.sub, stateMenu, true, menuDom);
                            } else {
                                menuDom = menuDom + '</li>';
                            }
                        //}
                    }
                    return menuDom + '</ul></li>';
                }
                
                let homeState = _.find(_.filter($state.get(), function(s) { return _.endsWith(s.name, ".home") }), function(s) {
                    let rootStateName = _.replace(s.name, '.home', '');
                    return _.startsWith($state.current.name, rootStateName);
                });
                let stateMenu = helperService.getMenuByState(menu, homeState.name);
                if (helperService.hasValidRoleForAction(userRole, stateMenu)) {
                    if (!_.isEmpty(stateMenu.sub)) {
                        let mainMenu = generateMenu(userRole, stateMenu.sub, stateMenu, false, "");
                        mainMenu = mainMenu + '<ul><li><a id="logout" href="#" ng-click="logout($event)">Log out {{username}}</a></li></ul>';
                        $("#left").html(mainMenu);
                    } else {
                        let mainMenu = `<li class='is-active-ancestor has_sub'><a ui-sref="${stateMenu.state}" ui-sref-opts="{reload: true}" class="ng-binding">${stateMenu.text}</a></li><ul><li><a id="logout" href="#" ng-click="logout()">Log out {{username}}</a></li></ul>`;
                        $("#left").html(mainMenu);
                    }
                }
            },
            controller:['menuProvider', '$rootScope', '$scope', '$state', 'securityService', 
                function(menu, $rootScope, $scope, $state, securityService, tokenService) {

                    $scope.username = securityService.getAutheticatedUserId();

                    $scope.logout = function(event) {
                        event.preventDefault();
                        securityService.logout();
                        $state.go("auth.login");
                    };

                    $scope.stateIsActive = function(state) {
                        let existingMenuMatch = $state.current.name === state;
                        let existingParentMenuMatch = $state.current.vparent && $state.current.vparent === state;
                        return existingMenuMatch || existingParentMenuMatch;
                    };
                }]
        }

    }
}

StateMenuDirective.factory.$inject = ['menuProvider', '$rootScope', '$state', 'securityService', '$timeout', 'helperService'];

export default StateMenuDirective;


// WEBPACK FOOTER //
// ./app/menu/state-menu.directive.js